import { consoleFilterPreferencesConfig } from '@/console/features/filter-preferences/config/console-filter-preferences-config';
import { consoleGroupsConfig } from '@/console/features/groups/config/console-groups-config';
import { consoleRbacConfig } from '@/console/features/rbac/config/console-rbac-config';
import { TAppConfig } from '@/shared/features/app-config/context/app-config-context.types';

export const consoleAppConfig: TAppConfig = {
  rbac: consoleRbacConfig,
  groups: consoleGroupsConfig,
  filterPreferences: consoleFilterPreferencesConfig,
};
